module.exports = __webpack_public_path__ + "static/media/sidebar-3.e482be75.jpg";